import * as request from './utils/requester';

export const getAll = (page) => request.get(`/tna?page=${page}`);

export const getById = (id) => request.get(`/tna/${id}`);


export const create = (data) => request.post('/tna', data);

export const edit = (data) => request.put(`/tna/${data._id}`, data);

export const del = (data) => request.del(`/tna/${data._id}`);


export const getOption = (option) => request.get(`/tna?option=${option}`);

// Service specific functions
export const getAllModules = (page) => request.get(`/tna/module/?page=${page}`);
export const getAllTnaDifferences = (page) => request.get(`/tna/difference?page=${page}`);
export const updateModuleGeneral = (data) => request.put(`/tna/module/general/${data._id}`, data);
export const getModuleById = (id) => request.get(`/tna/module/${id}`);
export const getAssignedModules = (id) => request.get(`/tna/module/assigned/${id}`);
export const updateModuleAta = (data) => request.put(`/tna/module/ata/${data.tnaModuleId}`, data);
export const updateTnaModuleAssigns = (tnaId, data) => request.put(`/tna/module/assigned/${tnaId}`, data);
export const updateMcqQuestions = (data) => request.put(`/tna/mcq/${data.tnaMcqId || 0}`, data);
export const lockTna = (tnaId, data) => request.post(`/tna/lock/${tnaId}`, data);
export const getLockedTnaById = (id) => request.get(`/tna/lock/${id}`);
